import { createSelector } from '@reduxjs/toolkit';
import { calcPaginationState } from 'utils/service';
import { AppState } from '../index';

const selectState = (state: AppState) => state.userCms;

export const selectUserCmsStatuses = createSelector(selectState, ({ isLoading, error, isInit }) => {
  return { isLoading, error, isInit };
});
export const selectUserCmsData = createSelector(selectState, ({ data }) => {
  return data;
});
export const selectUserCmsFilters = createSelector(selectState, ({ filters }) => {
  return filters;
});
export const selectUserCmsPagination = createSelector(selectState, ({ pagination }) => {
  return calcPaginationState(pagination);
});
export const selectUserCmsOrderBy = createSelector(selectState, ({ orderBy }) => {
  return orderBy;
});
